/* eslint-disable no-unused-vars */
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Slider } from "react-semantic-ui-range";
import { Divider, Form, FormGroup, Icon } from "semantic-ui-react";
import * as THREE from "three";
import { SettingsContext } from "../context";
import api from "../context/api";
import AccordionItem from "./AccordionItem";

const initialTypes = [
  { label: "Bake", value: "0" },
  { label: "not-bake", value: "1" },
];
function MaterialAdd({ onAddMaterial }) {
  const {
    editorProductInfo,
    companies,
    getCompanies,
    populateContextMaterials,
    exporter,
    authenticationToken,
    tagList,
    getTagGroups,
    tagGroupList,
    getTags,
    authorizationHeader,
    createTagForMaterial,
    transmissionParams,
    setTransmissionParams,
  } = useContext(SettingsContext);

  const [mesh, setMesh] = useState(null);
  const [checkerCloth, setCheckerCloth] = useState(null);
  const [materialGroups, setMaterialGroups] = useState([]);
  const [filteredMaterialGroups, setFilteredMaterialGroups] = useState([]);
  const [materialLabels, setMaterialLabels] = useState([]);
  const [productMaterialGroups, setProductMaterialGroups] = useState([]);
  const [materialName, setMaterialName] = useState("");
  const [type, setType] = useState(initialTypes[1].label);
  const [types] = useState(initialTypes);
  const [materialId, setMaterialId] = useState(null);
  const [materialCode, setMaterialCode] = useState("");
  const [company, setCompany] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [materialCompany, setMaterialCompany] = useState();
  const [materialSeriesName, setMaterialSeriesName] = useState("");
  const [materialDtoList, setMaterialDtoList] = useState([]);
  const [mtlThumbnail, setMtlThumbnail] = useState([]);
  const [tailing, setTailing] = useState(1);
  const [rotation, setTextureRotation] = useState(0);
  const [activeMtl, setActiveMtl] = useState({});
  const [selectedTagGroups, setSelectedTagGroups] = useState([]);

  const [selectedMaterialGroups, setSelectedMaterialGroups] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState([]);
  let [materialInfo] = useState({});
  var [modelViewer] = useState();
  const [bakeType, setBakeType] = useState(initialTypes[1]);
  const tagInputRef = useRef(null);

  useEffect(() => {
    getTags();
    getCompanies();
    populateMaterials();
    populateMaterialGroups();
    getTagGroups();
    populateProductMaterialGroups();
  }, []);

  useEffect(() => {
    function handleUpdateTransmissionParams(e) {
      const params = e.detail;

      const { name } = params;

      const prev = transmissionParams.find((p) => p.name === name);

      Object.keys(params)
        .filter((k) => k !== "name")
        .forEach((field) => {
          if (prev) {
            prev[field] = params[field];
            materialInfo[field] = params[field];
          } else {
            transmissionParams.push({ name, ...params[field] });
          }
        });
    }

    document.addEventListener(
      "update-transmission-parameter",
      handleUpdateTransmissionParams
    );

    return () => {
      document.removeEventListener(
        "update-transmission-parameter",
        handleUpdateTransmissionParams
      );
    };
  }, []);

  const filterOption = (candidate, input) => {
    return candidate.data.data.toLowerCase().includes(input.toLowerCase());
  };

  const addTag = async () => {
    await api.addTagToMaterial(selectedTags, materialId);
  };
  const populateMaterials = async (force) => {
    const materials = await populateContextMaterials(force);
    setMaterialLabels([]);
    setMaterialDtoList(materials);
    setMaterialLabels(
      materials.map((mtl) => {
        return {
          value: mtl?.id,
          label: (
            <div>
              <img
                loading="lazy"
                src={getImageUrl(mtl)}
                height="60px"
                width="60px"
              />
              {mtl?.name}
            </div>
          ),
          data: mtl?.name,
        };
      })
    );
  };

  const populateMaterialGroups = async () => {
    const res = await axios.get(
      process.env.REACT_APP_BACKEND_API + "material/group/list",
      authorizationHeader
    );

    let materialGroupsData = res.data.body || res.data || [];
    let materialGroups = materialGroupsData
      .filter(
        (m) =>
          m &&
          m.company &&
          m.name &&
          m.name.length > 0 &&
          !m.name.startsWith("self")
      )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((mtlGroup) => {
        return {
          value: mtlGroup.id,
          label: mtlGroup.company.name + " - " + mtlGroup.name,
          company: mtlGroup.company.id,
        };
      });
    setMaterialGroups(materialGroups);
    setFilteredMaterialGroups(materialGroups);
  };

  const populateMaterialsByGroup = async (groupId) => {
    const res = await axios.get(
      process.env.REACT_APP_BACKEND_API + "material/group/materials/" + groupId,
      authorizationHeader
    );
    const materials = res.data;
    setMaterialDtoList(materials);
    setMaterialLabels(
      materials.map((mtl) => {
        return {
          value: mtl?.id,
          label: (
            <div>
              <img src={getImageUrl(mtl)} height="60px" width="60px" />
              {mtl?.name}
            </div>
          ),
          data: mtl?.name,
        };
      })
    );
  };

  const populateMaterialsByCompany = async (companyId) => {
    const res = await axios.get(
      process.env.REACT_APP_BACKEND_API + "material/company/" + companyId,
      authorizationHeader
    );
    const materialGroupsMap = res.data;
    setMaterialDtoList(Object.values(materialGroupsMap).flat());
    setMaterialLabels(
      Object.keys(materialGroupsMap)
        .map((mg) =>
          materialGroupsMap[mg].map((mtl) => {
            return {
              value: mtl?.id,
              label: (
                <div>
                  <img src={getImageUrl(mtl)} height="60px" width="60px" />
                  {mg + " - " + mtl?.name}
                </div>
              ),
              data: mtl?.name,
            };
          })
        )
        .flat()
    );
  };

  const getImageUrl = (material) => {
    if (material?.diffuseMap?.uri512) return material?.diffuseMap.uri512;
    if (material?.diffuseMap?.uri1) return material?.diffuseMap.uri1;
    if (material?.diffuseMap?.uri2) return material?.diffuseMap.uri2;
    if (material?.diffuseMap?.uri4) return material?.diffuseMap.uri4;

    return "";
  };

  const populateSelectedMaterialGroups = async (materialId) => {
    const res = await axios.get(
      process.env.REACT_APP_BACKEND_API + "material/group/" + materialId,
      authorizationHeader
    );

    setSelectedMaterialGroups(
      res.data.map((mtl) => {
        return {
          value: mtl?.id,
          label: mtl?.name,
        };
      })
    );
  };

  const populateProductMaterialGroups = async () => {
    if (!editorProductInfo || !editorProductInfo.id) return;
    const res = await axios.get(
      process.env.REACT_APP_BACKEND_API +
        "material/group/product/" +
        editorProductInfo.id,
      authorizationHeader
    );

    setProductMaterialGroups(
      res.data.map((mtl) => {
        return {
          value: mtl?.id,
          label: mtl?.company?.name + " - " + mtl?.name,
        };
      })
    );
  };

  const resetFilter = () => {
    setMaterialId("");
    setMaterialCode("");
    setMaterialName("");
    setTailing(1);
    setSelectedTags(null);
    setTextureRotation(0);
    setActiveMtl({});
    setBakeType(initialTypes[1]);
    setType(initialTypes[1].label);
    setSelectedMaterialGroups([]);
    setSelectedMaterial(null);
    setFilteredMaterialGroups(materialGroups);
  };

  const handleFilterMaterialChanged = async (e) => {
    resetFilter();
    if (e && e.value > 0) {
      const groupId = e.value;
      populateMaterialsByGroup(groupId);
    } else {
      populateMaterials(false);
    }
  };

  const handleMaterialCompanyChange = async (e) => {
    resetFilter();
    if (e) {
      const filteredMg = materialGroups.filter((mg) => {
        return mg.company == e.value;
      });
      setFilteredMaterialGroups(filteredMg);
    }

    setMaterialCompany(e);
    populateMaterialsByCompany(e.value);
  };

  const handleMaterialChanged = (e) => {
    if (!e) {
      resetFilter();
      return;
    }
    if (e.value && e.value != "") {
      api.getTagsByMaterialId(e.value).then((res) => {
        setSelectedTags(
          res.data.map((tags) => {
            return { value: tags.id, label: tags.name };
          })
        );
      });
    }

    setSelectedMaterial(e);
    var activeMtl = materialDtoList.filter(function (item) {
      return item.id == e.value;
    })[0];

    if (activeMtl?.orginalGlb) {
      createTagForMaterial({
        src: activeMtl?.orginalGlb + "?v=" + Math.random() * 100,
      });
      if (onAddMaterial) onAddMaterial(activeMtl);
      let modelViewer = document.getElementsByTagName("sugar-model-viewer")[0];
      // modelViewer.addEventListener( "preload", () => {
      //   modelViewer.loadGltf( "https://s3.eu-central-1.amazonaws.com/cdn.sugartech/mottobucket/glbs/cloth_backdrop.glb" )
      //     .then( ( _model ) => setCheckerCloth( _model ) );
      //   modelViewer.scene().traverse( ( c ) => {
      //     if ( c.type == "Mesh" && c.material?.type != "ShadowMaterial" ) {
      //       setMesh( c );
      //     }
      //   } );
      // } )
      // modelViewer.jointsportController.updateSceneAfterModelChanges();
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("glb-loaded"));
        modelViewer.style.display = "block";
        modelViewer.style.height = "100vh";
      }, 2000);
    }

    initialTypes.map((type) => {
      let mType = activeMtl.type != null ? activeMtl.type : "bake";
      if (type.label.toLocaleLowerCase() === mType.toLocaleLowerCase()) {
        setBakeType(type);
        setType(type.label);
      }
    });

    setMaterialId(activeMtl.id);
    setMaterialCode(activeMtl.code);
    setMaterialName(activeMtl.name);
    setTailing(activeMtl.size);
    setTextureRotation(activeMtl.rotation / (Math.PI / 180.0));
    setActiveMtl(activeMtl);

    populateSelectedMaterialGroups(activeMtl.id);
  };

  const handleMaterialGroupChanged = (e) => {
    setSelectedMaterialGroups(e);
  };

  const handleProductMaterialsChanged = (e) => {
    setProductMaterialGroups(
      e.map((group) => {
        return { value: group.value, label: group.label };
      })
    );
  };

  const changeMaterialTailing = async () => {
    const modelViewer = document.getElementById("modelViewer");
    const scene = modelViewer?.scene();
    const object = getModelContainer(scene);

    object?.traverse((n) => {
      if (n.material?.map) {
        n.material.map.wrapS = THREE.RepeatWrapping;
        n.material.map.wrapT = THREE.RepeatWrapping;
        n.material.map.repeat.set(tailing, tailing);
        if (n.material.normal) {
          n.material.normal.wrapS = THREE.RepeatWrapping;
          n.material.normal.wrapT = THREE.RepeatWrapping;
          n.material.normal.repeat.set(tailing, tailing);
        }

        n.material.needsUpdate = true;
      }
    });
  };

  const changeTextureRotation = async (value) => {
    const modelViewer = document.getElementById("modelViewer");
    const scene = modelViewer?.scene();
    const object = getModelContainer(scene);
    object?.traverse((n) => {
      if (n.material?.map) {
        changeTextureRotationOfMap(n.material.map, value);
      }
      if (n.material?.normalMap) {
        changeTextureRotationOfMap(n.material.normalMap, value);
      }
      if (n.material?.metalnessMap) {
        changeTextureRotationOfMap(n.material.metalnessMap, value);
      }
      if (n.material?.roughnessMap) {
        changeTextureRotationOfMap(n.material.roughnessMap, value);
      }
      if (n.material?.emissiveMap) {
        changeTextureRotationOfMap(n.material.emissiveMap, value);
      }
      if (n.material?.aoMap) {
        changeTextureRotationOfMap(n.material.aoMap, value);
      }
      if (n.material?.alphaMap) {
        changeTextureRotationOfMap(n.material.alphaMap, value);
      }
      if (n.material) {
        n.material.needsUpdate = true;
      }
    });
  };

  const changeTextureRotationOfMap = async (localMap, value) => {
    localMap.center = new THREE.Vector2(0.5, 0.5);
    localMap.rotation = value * (Math.PI / 180.0);
    localMap.wrapS = THREE.RepeatWrapping;
    localMap.wrapT = THREE.RepeatWrapping;
    localMap.needsUpdate = true;
  };

  const handleOnChangeTailing = (e) => {
    setTailing(e?.target?.value);
    changeMaterialTailing();
  };

  const handleOnChangeTextureRotation = (e) => {
    setTextureRotation(e?.target?.value);
    changeTextureRotation();
  };

  const handleTypeChange = (e) => {
    {
      setType(e.label);
    }
  };

  const saveProductToMaterialGroup = async () => {
    console.log("saveProductToMaterialGroup");
    if (!editorProductInfo || !editorProductInfo.id) return;
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Ürün kumaş gruplarına ekleniyor.",
      })
    );

    let params = {
      productId: editorProductInfo.id,
      materialGroupId: productMaterialGroups.map((e) => {
        return e.value;
      }),
    };

    const url =
      process.env.REACT_APP_BACKEND_API +
      "material/group/product/save?" +
      new URLSearchParams(params);
    console.log("url is", url, "authorizatioHeader", authorizationHeader);
    axios.get(url, authorizationHeader).then(
      (res) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Ürüne kumaş grupları eklendi.",
          })
        );
        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      },
      (rej) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Ürüne kumaş grubu EKLENEMEDİ.",
          })
        );
        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      }
    );
  };

  const saveMaterialGroup = () => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Material Group Ekleniyor.",
      })
    );

    let mGroup = {
      name: materialSeriesName,
      company:
        company && company.value
          ? {
              id: company.value,
              name: company.label,
            }
          : null,
    };
    axios
      .post(process.env.REACT_APP_BACKEND_API + `material/savegroup`, mGroup, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then(
        (res) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "kumaş serisi eklend",
            })
          );
          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        },
        (rej) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: materialSeriesName + "eklenemedi.",
            })
          );
          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }
      );
  };

  const deleteMaterial = async () => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", { detail: "Kumaş siliniyor..." })
    );

    try {
      await api.deleteMaterial(materialId);

      setMaterialId("");
      document.dispatchEvent(
        new CustomEvent("close-editor-popup", {
          detail: "Ops bütün Kumaşlar Silindi.",
        })
      );
    } catch (e) {
      document.dispatchEvent(
        new CustomEvent("close-editor-popup", {
          detail: "Kumaşlar silinirken hata oluştu.",
        })
      );
    }
  };

  const uploadMaterial = async () => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", { detail: "Kumaş ekleniliyor..." })
    );

    modelViewer = document.getElementById("modelViewer");
    let scene = modelViewer?.scene();

    let materialInfoData = activeMtl;
    materialInfoData.id = materialId;
    materialInfoData.groupId = selectedMaterialGroups.map((e) => {
      return e.value;
    });
    materialInfoData.code = materialCode;
    materialInfoData.size = tailing;

    materialInfoData.rotation = rotation * (Math.PI / 180.0);
    materialInfoData.type = type ? type : null;
    materialInfoData.name = materialName;

    let allSceneMaterials = [];

    scene.traverse(function (pobject) {
      let object = pobject;
      if (object.material != null && object.material.type != "ShadowMaterial") {
        allSceneMaterials.push(object.material);
      }
    });

    materialInfoData.roughnessFactor = allSceneMaterials[0].roughness;
    materialInfoData.metallicFactor = allSceneMaterials[0].metalness;
    materialInfoData.color =
      allSceneMaterials[0].color.getHexString("SRGBColorSpace");
    materialInfoData.emissiveIntensity = allSceneMaterials[0].emissiveIntensity;
    materialInfoData.emissiveColor =
      allSceneMaterials[0].emissive.getHexString("SRGBColorSpace");
    materialInfoData.opacity = allSceneMaterials[0].opacity;
    materialInfoData.depthWrite = allSceneMaterials[0].depthWrite;
    materialInfoData.depthTest = allSceneMaterials[0].depthTest;
    materialInfoData.transparent = allSceneMaterials[0].transparent ? 1 : 0;
    materialInfoData.sheenColor = allSceneMaterials[0].sheen
      ? allSceneMaterials[0].sheen.getHexString("SRGBColorSpace")
      : undefined;

    if (allSceneMaterials[0].map?.offset) {
      materialInfoData.offsetX = allSceneMaterials[0].map.offset.x;
      materialInfoData.offsetY = allSceneMaterials[0].map.offset.y;
    }

    materialInfo = { ...materialInfo, ...materialInfoData };
    let glb = await exporter.parse(getModelContainer(scene), true, false);
    sendMaterialToAdd(glb);
  };

  const getModelContainer = (scene) => {
    let modelCOntainer;
    scene.traverse((m) => {
      if (m.name == "ModelContainer") modelCOntainer = m;
    });
    return modelCOntainer;
  };

  const handleTagsGroupChanged = (e) => {
    setSelectedTagGroups(
      e.map((tags) => {
        return { value: tags.value, label: tags.label };
      })
    );
  };
  const addTagGroup = async () => {
    await api.addTagGroupsToMaterial(selectedTagGroups, materialId);
  };
  const sendMaterialToAdd = async (glb) => {
    const json = JSON.stringify(materialInfo);
    let formData = new FormData();
    formData.append(
      "glbFile",
      new Blob([new Uint8Array(glb, 0, glb?.byteLength)])
    );
    formData.append(
      "materialInfo",
      new Blob([json], {
        type: "application/json",
      })
    );
    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + "material/savefromglb",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authenticationToken,
      },
    })
      .then(
        async (res) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Material Group Kumaş olarak eklendi.",
            })
          );
          api.updateTagsOfMaterial(selectedTags, res.data.id);
          if (selectedTagGroups.length > 0) {
            api.addTagGroupsToMaterial(selectedTagGroups, res.data.id);
          }
          setSelectedTagGroups(null);

          await populateMaterials(true);
          return res;
        },
        (rej) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Material Group eklenirken hata oluştu.",
            })
          );
          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }
      )
      .then(() => {
        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      })
      .catch((err) => {
        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      });
  };

  const handleCopyClipboard = async () => {
    const selectedMaterialGropsString = JSON.stringify(selectedMaterialGroups);
    await navigator.clipboard.writeText(selectedMaterialGropsString);
  };
  const handlePasteClipboard = async () => {
    const selectedMaterialGropsString = await navigator.clipboard.readText();
    if (selectedMaterialGropsString) {
      const smgs = JSON.parse(selectedMaterialGropsString);
      setSelectedMaterialGroups(smgs);
    }
  };

  const filterOptionMulti = (candidate, input) => {
    return (
      candidate.data.__isNew__ ||
      candidate.label.toUpperCase().trim().includes(input.toUpperCase().trim())
    );
  };

  const [isLoading, setIsLoading] = useState(false);

  const createTag = async (label) =>
    new Promise((resolve, reject) => {
      document.dispatchEvent(
        new CustomEvent("open-form-popup", {
          detail: {
            formFields: [
              {
                label: "Name",
                name: "name",
                type: "text",
                value: label,
              },
              {
                label: "Type",
                name: "type",
                type: "select",
                value: "MATERIAL",
                options: [
                  { value: "MATERIAL", label: "Material" },
                  { value: "ROOM", label: "Room" },
                  { value: "COLOR", label: "Color" },
                  { value: "STYLE", label: "Style" },
                  { value: "CUSTOM", label: "Custom" },
                ],
              },
            ],
            onSubmit: (async (data) => {
              api.createNewTag(data).then((res) => {
                if (res.data.status == "error") {
                  reject(res.data.error);
                }
                resolve(res.data);
              });
            }).bind(this),
            onReject: ((err) => {
              resolve(null);
            }).bind(this),
          },
        })
      );
    });

  const handleCreateTag = async (inputValue) => {
    setIsLoading(true);
    createTag(inputValue)
      .then((newOption) => {
        setIsLoading(false);
        if (newOption) {
          setSelectedTags((prev) => [
            ...prev,
            {
              name: newOption.name,
              value: newOption.id,
              label: newOption.name + "-" + newOption.type,
            },
          ]);
        }
        document.dispatchEvent(new CustomEvent("close-form-popup"));
        tagInputRef.current.focus();
      })
      .catch((err) => {
        setIsLoading(false);
        document.dispatchEvent(new CustomEvent("close-form-popup"));
        document.dispatchEvent(
          new CustomEvent("open-editor-popup", { detail: "Error: " + err })
        );
        tagInputRef.current.focus();
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }, 1000);
      });
  };

  return (
    <div>
      <AccordionItem header="Material Group">
        <Form>
          <Form.Group>
            <Form.Field width={6}>
              <div>
                <Select
                  menuPosition="fixed"
                  isSearchable
                  isClearable
                  options={companies}
                  selection
                  placeholder="Select Company"
                  value={company}
                  onChange={(e) => {
                    if (e?.value) setCompany(e);
                  }}
                />
              </div>
            </Form.Field>

            <Form.Field>
              <input
                value={materialSeriesName || ""}
                placeholder="materialSeriesName"
                onChange={(e) => setMaterialSeriesName(e.target.value)}
              />
            </Form.Field>

            <Form.Field width={3}>
              <button
                style={{ float: "left" }}
                className="saveButton"
                onClick={() => saveMaterialGroup()}
              >
                <Icon name="upload" /> Save
              </button>
            </Form.Field>
          </Form.Group>
        </Form>

        <Divider horizontal>-</Divider>

        <div className="accordion">
          <div>
            <Select
              menuPosition="fixed"
              isSearchable
              isClearable
              options={materialGroups}
              onChange={(e) => handleProductMaterialsChanged(e)}
              selection
              value={productMaterialGroups}
              isMulti={true}
              placeholder="Select Material Group"
            />

            <button
              size="tiny"
              className="saveButton"
              style={{ float: "left" }}
              onClick={saveProductToMaterialGroup}
            >
              <Icon name="dot circle outline" />
              Save
            </button>
          </div>
        </div>

        <br />
      </AccordionItem>

      <AccordionItem header="Add Material As Glb">
        <div className="accordion">
          <Form style={{ marginBottom: "2em" }}>
            <Form.Group>
              <div style={{ width: "100%" }}>
                <Select
                  menuPosition="fixed"
                  isSearchable
                  isClearable
                  options={companies}
                  selection
                  placeholder="Select Company"
                  value={materialCompany}
                  onChange={handleMaterialCompanyChange}
                />
              </div>
            </Form.Group>
            <Form.Group>
              <div style={{ width: "100%" }}>
                <Select
                  menuPosition="fixed"
                  isSearchable
                  isClearable
                  options={filteredMaterialGroups}
                  onChange={handleFilterMaterialChanged}
                  selection
                  isMulti={false}
                  placeholder="Select to Filter Materials"
                />
              </div>
            </Form.Group>

            <Form.Group>
              <div style={{ width: "100%" }}>
                <Select
                  menuPosition="fixed"
                  isSearchable
                  isClearable
                  filterOption={filterOption}
                  options={materialLabels}
                  onChange={(e) => handleMaterialChanged(e)}
                  value={selectedMaterial}
                  selection
                  isMulti={false}
                  placeholder="Select to Update Materials"
                />
              </div>
            </Form.Group>

            <Form.Group>
              <div style={{ width: "100%" }}>
                <Select
                  menuPosition="fixed"
                  isSearchable
                  isClearable
                  options={filteredMaterialGroups}
                  onChange={(e) => handleMaterialGroupChanged(e)}
                  selection
                  value={selectedMaterialGroups}
                  isMulti={true}
                  placeholder="Select MaterialGroup"
                />
              </div>
            </Form.Group>
            <Form.Group>
              <button
                className="saveButton"
                onClick={() => {
                  handleCopyClipboard();
                }}
                size="tiny"
              >
                Copy
              </button>

              <button
                className="editorButton"
                onClick={() => handlePasteClipboard()}
                style={{ backgroundColor: "blue" }}
              >
                Paste
              </button>
            </Form.Group>
            <Form.Group>
              <div style={{ width: "100%" }}>
                <CreatableSelect
                  isSearchable
                  isClearable
                  ref={tagInputRef}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  isMulti={true}
                  options={tagList}
                  selection
                  placeholder="Select Tags"
                  value={selectedTags}
                  getOptionLabel={(option) => `${option.label}`}
                  filterOption={filterOptionMulti}
                  onCreateOption={handleCreateTag}
                  onChange={setSelectedTags}
                />
                <button
                  style={{ margin: 5, float: "right" }}
                  className="saveButton"
                  onClick={() => {
                    if (materialId != "" && materialId) {
                      addTag();
                    } else {
                      alert("material mevcut değil");
                    }
                  }}
                >
                  {" "}
                  <Icon name="lab" /> add tag
                </button>
              </div>
            </Form.Group>
            <Form.Group>
              <Form.Field width="5" style={{ margin: 5, float: "left" }}>
                <label className="text" style={{ margin: 10, float: "left" }}>
                  Tailing
                </label>
                <Form.Input
                  value={tailing || 1}
                  onChange={(e) => {
                    handleOnChangeTailing(e);
                  }}
                />
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  value={tailing || 1}
                  settings={{
                    max: 16,
                    step: 0.02,
                    min: 0.01,
                    onChange: (value) => {
                      setTailing(value);
                      changeMaterialTailing();
                    },
                  }}
                />
              </Form.Field>
            </Form.Group>

            <Form.Group>
              <Form.Field width="5" style={{ margin: 5, float: "left" }}>
                <label className="text" style={{ margin: 10, float: "left" }}>
                  Texture Rotation
                </label>
                <Form.Input
                  value={rotation}
                  onChange={(e) => {
                    handleOnChangeTextureRotation(e);
                  }}
                />
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  value={rotation}
                  settings={{
                    max: 360,
                    step: 0.1,
                    min: 0,
                    onChange: (value) => {
                      changeTextureRotation(value);
                      setTextureRotation(value);
                    },
                  }}
                />
              </Form.Field>
            </Form.Group>

            <FormGroup>
              <Form.Field>
                <label
                  className="textArea"
                  value={materialName}
                  style={{ color: "white" }}
                >
                  Material Name
                </label>
                <input
                  /*defaultValue={materialName}*/ value={materialName || ""}
                  onChange={(e) => setMaterialName(e.target.value)}
                />
              </Form.Field>
            </FormGroup>

            <FormGroup>
              <Form.Field>
                <label
                  className="textArea"
                  value={materialCode}
                  style={{ color: "white" }}
                >
                  Material Code
                </label>
                <input
                  /*defaultValue={materialCode}*/ value={materialCode || ""}
                  onChange={(e) => setMaterialCode(e.target.value)}
                />
              </Form.Field>
            </FormGroup>

            <FormGroup>
              <Form.Field>
                <label className="textArea" style={{ color: "white" }}>
                  {" "}
                  Bake Type
                </label>
                <input disabled defaultValue={type || ""} />
              </Form.Field>
            </FormGroup>

            <FormGroup>
              <div style={{ width: "100%", margin: "5px", color: "black" }}>
                <Select
                  menuPosition="fixed"
                  selection
                  onChange={handleTypeChange}
                  options={types}
                  defaultValue={bakeType}
                  placeholder="Changes Type"
                />
              </div>
            </FormGroup>

            <FormGroup>
              <Form.Field>
                <label className="textArea" style={{ color: "white" }}>
                  {" "}
                  Thumbnail
                </label>
              </Form.Field>

              <Form.Field>
                <label htmlFor="uploadMtl">
                  <Icon name="upload" size="big" color="grey" />{" "}
                </label>
                <input
                  type="file"
                  onChange={(e) => setMtlThumbnail(e.target.files[0])}
                  hidden
                  id="uploadMtl"
                />
              </Form.Field>
            </FormGroup>

            <FormGroup>
              <button
                className="saveButton"
                onClick={() => {
                  uploadMaterial();
                }}
                size="tiny"
              >
                <Icon name="upload" />
                Save
              </button>

              <button
                className="editorButton"
                onClick={() => deleteMaterial()}
                style={{ backgroundColor: "red" }}
              >
                X Delete X
              </button>
            </FormGroup>
          </Form>
        </div>
      </AccordionItem>
    </div>
  );
}
export default MaterialAdd;
